import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { compose } from 'recompose';
import { reduxForm } from 'redux-form';
import { InputField, Input } from '@components/form';

const enhance = compose<any, any>(
  reduxForm({
    form: 'module-protocols-row'
  })
);
export const View: React.SFC<any> = ({ closeItem }) => (
  <div>
    <form className="layout">
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
        <Row>
          <Col md={12}>
            <InputField
              component={Input}
              multiLine={true}
              id="note"
              name="note"
              label={'Text záznamu'}
              rowsMax={10}
              disabled={true}
              style={{ maxHeight: '60vh' }}
              inputStyle={{ maxHeight: '60vh' }}
              textareaStyle={{ maxHeight: '56vh' }}
            />
          </Col>
        </Row>
      </Grid>
      <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
    </form>
  </div>
);

export const TripsHistoriesDetailForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/trips/TripsHistoriesDetailForm.tsx